import { string } from "yup";

export default string()
  .min(12, "HTS must be at least 10 characters long, separated by dots. Ex. 1234.56.7890")
  .max(12, "HTS must contain at most 10 characters long, separated by dots. Ex. 1234.56.7890")
  .matches(/[0-9]\./);
